var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurve3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 94,
    viewBox: "0 0 253 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.972 -17.8957C141.26 84.9508 11.7066 120.577 -80.1725 62.869C-172.052 5.16122 -192.618 -124.752 -124.906 -227.599C-57.1935 -330.445 72.3604 -366.071 164.239 -308.364C256.119 -250.656 276.685 -120.742 208.972 -17.8957Z",
    stroke: "#1F3549",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve3);
export default __webpack_public_path__ + "static/media/curve3.8b4b1c8e0e9a745c48db8d45e4b7847a.svg";
export { ForwardRef as ReactComponent };